import * as React from 'react';

import footer from 'components/lexemes/footer';
import interfaceLanguages from 'lib/languages.json';

import Select from 'components/select/select';

type Props = {
  lang: string;
  onChange?: (lang: string) => void;
};

const LanguageSelector: React.FC<Props> = ({ lang, onChange }) => {
  const languagesList = React.useMemo(() => {
    return interfaceLanguages.map(({ name, code }) => ({
      title: name,
      value: code,
      href: `/privacy-policy/${code}`,
    }));
  }, []);

  return (
    <Select
      onChange={onChange}
      defaultValue={lang}
      options={languagesList}
      hasMaxHeight={true}
      a11y={{
        label: footer.lxLanguageSelection(),
      }}
    />
  );
};

export default LanguageSelector;
